import { InterstateDealSummarySections, useDealSummary } from '@makemydeal/dr-dash-components';
import { List } from '@interstate/components/List';

const DealRecap = () => {
    const { showDetailedView } = useDealSummary();

    return (
        <>
            <List data-testid="deal-recap-summary">
                <InterstateDealSummarySections.FrontEndProfit />
                <InterstateDealSummarySections.BackEndProfit />
                <InterstateDealSummarySections.GrossProfit />
                <InterstateDealSummarySections.InterstateTrades />
                {showDetailedView && <InterstateDealSummarySections.InterstateDealPulse />}
            </List>
            {!showDetailedView && <InterstateDealSummarySections.InterstateDealPulse />}
        </>
    );
};

export default DealRecap;
